var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('form',[_c('string-form-field',{attrs:{"label":"Nome","value":_vm.value.name,"disabled":_vm.disabled,"error":_vm.findError('name')},on:{"input":function($event){return _vm.propertyChanged('name', $event)}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }